import { render, staticRenderFns } from "./workManagement.vue?vue&type=template&id=ba3adc92&"
import script from "./workManagement.vue?vue&type=script&lang=js&"
export * from "./workManagement.vue?vue&type=script&lang=js&"
import style0 from "./workManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports